import { RELEASE_SUCCESS, RELEASE_FAILED, CLEAR_RELEASE } from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RELEASE_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case RELEASE_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_RELEASE:
      return initialState;
    default:
      return state;
  }
};
